import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const TOAST_DURATION_MS = 6000;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      className="group"
      richColors
      closeButton
      toastOptions={{
        duration: TOAST_DURATION_MS,
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-neutral-0 group-[.toaster]:text-neutral-900 group-[.toaster]:border-neutral-200 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-neutral-500",
          actionButton: "group-[.toast]:bg-neutral-900 group-[.toast]:text-neutral-50",
          cancelButton: "group-[.toast]:bg-neutral-100 group-[.toast]:text-neutral-500",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
